import { useParams, Link } from 'react-router-dom';
import { projects } from '../data';
import { motion } from 'framer-motion';

function ProjectDetail() {
  const { id } = useParams();
  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return <div className="container mx-auto px-4 py-16">Project not found</div>;
  }

  return (
    <div className="container mx-auto px-4 py-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-dark-blue">{project.title}</h1>
        <img
          src={project.image}
          alt={project.title}
          className="mt-6 w-full h-96 object-cover rounded-lg"
        />
        <p className="mt-6 text-lg text-gray-600">{project.details}</p>
        <Link
          to="/projects"
          className="mt-8 inline-block bg-sky-blue text-white py-2 px-4 rounded hover:bg-dark-blue transition"
        >
          Back to Projects
        </Link>
      </motion.div>
    </div>
  );
}

export default ProjectDetail;